import React, { useEffect, useState } from "react";
import logo from "../../../assets/img/logo-1.png";
import { Link } from "react-router-dom";
import styleNewPassword from "./NewPassword.module.css";
import InputElement from "../../form/InputElement";
import ValidateResetPassword from "../../../validations/ValidateResetPassword";
import { checkResetPassValidty, resetPassword } from "../../../adapters/apis/auth/auth";
import { useSearchParams, useNavigate } from "react-router-dom";

const NewPassword = () => {
  const [newPassword, setNewPassword] = useState({
    password: "",
    confirm_password: "",
  });
  const [newPasswordError, setNewPasswordError] = useState({
    password: "",
    confirm_password: "",
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const token = searchParams.get("token");
 // const email = searchParams.get("email");
  const email = searchParams.get("email")?.replace(/ /g, "+");
  const mobile = searchParams.get("mobile")?.replace(/ /g, "+");
  function handleChange(parentCompenent, compenent, key, value) {
    setNewPassword((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
  function setError(key, value) {
    setNewPasswordError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }
  function checkValidity(){
    const payload = { 
      token: token,  
    };
    if (email) { 
      payload.email = email; 
    } else if (mobile) { 
      payload.mobile = mobile; 
    }
    checkResetPassValidty(payload).then((res) => {
    }).catch((error) => {
      navigate(`/check-reset-password-validity`);
    });
  }
  function setNewPass() {
    // if (ValidateResetPassword(setError, newPassword)) {
    const payload = { 
      token: token, 
      password: newPassword["password"], 
      password_confirmation: newPassword["confirm_password"], 
    };
    if (email) { 
      payload.email = email; 
    } else if (mobile) { 
      payload.mobile = mobile; 
    }
    setLoading(true);
      checkValidity();
      resetPassword(payload)
        .then(async (res) => {
          setSuccess(
            res.data.message +
              " سوف يتم تحويلك إلي صفحة تسجيل الدخول خلال 5 ثواني"
          );
          await setTimeout(function () {
            setLoading(false);
            navigate("/login", { replace: true });
          }, 5000);
        })
        .catch((error) => {
          setSuccess(error.response.data.errors);
          setLoading(false);
        });
    // }
  }

  useEffect(()=>{
      checkValidity();
  },[]);

  return (
    <section className={styleNewPassword["new-password-section"]}>
      <div className="container">
        <div className="row justify-content-center pt-5">
          <div className="col-md-5">
            <div className={`card ${styleNewPassword["card"]}`}>
              <div className="text-center mt-5">
                <Link to="/">
                  <img src={logo} alt="logo" />
                </Link>
              </div>
              <div
                className={`${styleNewPassword["card-body"]} card-body my-5`}
              >
                <InputElement
                  allowedPattern={/^[A-Za-z0-9\-_!@#$%^&*+=\[\]{};\\':"\|,.<>\/?`]*$/}
                  name="password"
                  mb4="mb-4 parent-password"
                  labelHtmlFor="password"
                  labelClassName={` required ${styleNewPassword["form-label"]} form-label`}
                  labelText="كلمة المرور الجديدة"
                  inputType="password"
                  inputClassName={`${styleNewPassword["form-control"]} form-control`}
                  inputID="password"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  // pText={newPasswordError.password}
                  value={newPassword.password}
                  onChange={handleChange}
                  pText={success.password}
                />
                <InputElement
                  allowedPattern={/^[A-Za-z0-9\-_!@#$%^&*+=\[\]{};\\':"\|,.<>\/?`]*$/}                  
                  name="confirm_password"
                  mb4="mb-4 parent-password"
                  labelHtmlFor="confirm_password"
                  labelClassName={` required ${styleNewPassword["form-label"]} form-label`}
                  labelText="تأكيد كلمة المرور الجديدة"
                  inputType="password"
                  inputClassName={`${styleNewPassword["form-control"]} form-control`}
                  inputID="confirm_password"
                  pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                  // pText={newPasswordError.confirm_password}
                  value={newPassword.confirm_password}
                  onChange={handleChange}
                  pText={success.password_confirmation}
                />
                <div
                  className={`${styleNewPassword["login-btn"]} text-center mt-5`}
                >
                  <button
                    onClick={setNewPass}
                    id="new_password_submit_btn"
                    className={`${styleNewPassword["btn-login"]} mb-3 d-block`}
                    disabled={loading}
                  >
                    إعادة تعيين كلمة المرور
                  </button>
                  <button
                    onClick={() => navigate("/login", { replace: true })}
                    id="new_password_submit_btn"
                    className={`${styleNewPassword["btn-bkToLogin"]} mb-4 d-block`}
                  >
                  إلغاء
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewPassword;
